import { useSelector } from "react-redux";
import { getLockedProfileFields, getVisibleProfileFields, isProfileConfigured } from "../program";
import { resolveProfileCrmConsents } from "../profile";
import type { CustomerProfileValues } from "../profile";
import { selectLoyaltyChannelDefId, selectLoyaltyProgramDetails } from "../selectors";

/**
 * What a customer form needs to draw `CustomerProfileSection` and to save what it edited, so
 * neither app re-derives a profile rule.
 *
 * - `card` — spread onto the section: the fields the CRM config shows, the dates the SAVED
 *   record has locked, and whether the consent rows show.
 * - `crmConsents` — the consents the rows display (`values.crmConsents`).
 * - `payloadContext` — hand it to `mergeCustomerProfile` when building the save payload.
 *
 * Pass the stored customer (`customerStore.customerInfo`), never the form.
 */
export function useCustomerProfile(
  customer?: {
    birthDate?: string | null;
    anniversaryDate?: string | null;
    crmConsents?: CustomerProfileValues["crmConsents"];
  } | null,
) {
  const programDetails = useSelector(selectLoyaltyProgramDetails);
  const channelDefId = useSelector(selectLoyaltyChannelDefId);
  return {
    card: {
      visibleFields: getVisibleProfileFields(programDetails),
      lockedFields: getLockedProfileFields(customer),
      showConsents: isProfileConfigured(programDetails),
    },
    crmConsents: resolveProfileCrmConsents(customer?.crmConsents),
    payloadContext: { programDetails, channelDefId },
  };
}
